import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PendingChangesService {
  customText: string;
  location: string;
  private unsavedChanges = false;
  private onDiscard: () => void = null;

  constructor() {
    window.addEventListener('beforeunload', (event) => {
      if (this.unsavedChanges) {
        event.preventDefault();
        event.returnValue = '';
      }
    });
  }

  setUnsavedChanges(status: boolean, customText: string = null, location: string = null, onDiscard: () => void = null): void {
    this.customText = customText;
    this.unsavedChanges = status;
    this.location = location;
    this.onDiscard = onDiscard;
  }

  discardChanges(): void {
    const onDiscard = this.onDiscard;

    this.setUnsavedChanges(false);
    onDiscard?.();
  }

  hasUnsavedChanges(): boolean {
    return this.unsavedChanges;
  }
}
